import React from 'react';
import MonacoEditor from './MonacoEditor';
import { useTabStore } from '../stores/tabStore';

const EditorArea: React.FC = () => {
  const { activeTabId, tabs, updateTabContent } = useTabStore();
  const activeTab = tabs.find(tab => tab.id === activeTabId);

  if (!activeTab) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500">
        Select a file to edit
      </div>
    );
  }

  // Determine language based on file extension
  const getLanguage = (path: string) => {
    const ext = path.split('.').pop()?.toLowerCase();
    switch(ext) {
      case 'js': return 'javascript';
      case 'jsx': return 'javascript';
      case 'ts': return 'typescript';
      case 'tsx': return 'typescript';
      case 'py': return 'python';
      case 'html': return 'html';
      case 'css': return 'css';
      case 'json': return 'json';
      case 'md': return 'markdown';
      default: return 'text';
    }
  };

  return (
    <div className="flex flex-col h-full">
      <div className="bg-gray-800 p-2 flex justify-between items-center">
        <div className="text-sm text-gray-300">
          {activeTab.title}
        </div>
        <div>
          <select
            className="bg-gray-700 text-white text-sm px-2 py-1 rounded"
            value={getLanguage(activeTab.path)}
            onChange={(e) => console.log('Language changed to:', e.target.value)}
          >
            <option value="javascript">JavaScript</option>
            <option value="typescript">TypeScript</option>
            <option value="python">Python</option>
            <option value="html">HTML</option>
            <option value="css">CSS</option>
            <option value="json">JSON</option>
            <option value="markdown">Markdown</option>
          </select>
        </div>
      </div>
      <div className="flex-1">
        <MonacoEditor
          value={activeTab.content}
          language={getLanguage(activeTab.path)}
          onChange={(value) => updateTabContent(activeTab.id, value)}
        />
      </div>
    </div>
  );
};

export default EditorArea;